'use strict';

var pMap = require('p-map');
module.exports = function (iterable, options) {
  return pMap(iterable, function (element) {
    return element();
  }, options);
};